import React from "react";
import {useModalRouting} from "../../utils/useModalRouting";
import {useRouter} from "next/router";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
  fetchCampaigns,
  reset as resetCampaignList,
  selectCurrentPage,
  setCurrentPage
} from "../../redux/campaign/campaignListSlice";
import {Modal} from "../modals/Modal";
import {reset} from "../../redux/campaign/campaignDetailSlice";
import {CampaignDetailView} from "./CampaignDetailView";

export const CampaignDetailModal: React.FC<any> = () => {
  const { onClose, isOpen } = useModalRouting();
  const router = useRouter()
  const campaignId = router.query.campaign_id as string | undefined
  const dispatch = useAppDispatch();
  const pageNumber = useAppSelector(selectCurrentPage)

  return <Modal
    className="md:max-w-screen-7/8"
    isOpen={isOpen('campaign_detail')}
    onClose={() => {
      dispatch(reset())
      onClose()

      dispatch(resetCampaignList())
      if (pageNumber === 1) {
        dispatch(fetchCampaigns(pageNumber))
      } else {
        dispatch(setCurrentPage(1))
      }
    }}
  >
    <CampaignDetailView onClose={onClose} campaignId={campaignId} />
  </Modal>
}